import './featured-label.scss';
